import React from 'react';

const ExcelExport = ({ onExport, className }) => {
  const handleClick = () => {
    if (onExport) {
      onExport();
    }
  };

  return (
    <button onClick={handleClick} className={className}>
      Экспорт в Excel
    </button>
  );
};

export default ExcelExport;
